<template>
    <div class="vertical-center">
        <h2>Water Point Info</h2>
        <PointInfo :source="source" :date="date" />
    </div>
</template>

<script lang="ts">
import PointInfo from './PointInfo.vue'

export default {
    name: 'SideBar',
    components: {
        PointInfo
    },
    props: {
        source: Object,
        date: Date
    }
};
</script>

<style lang="scss" scoped>
$blue: #0079c1;
$gray: #959595;
$white: #fff;

// .container {
// //   height: 200px;
// //   position: relative;
//   border: 3px solid green;
// }

.vertical-center {
  margin: 0;
//   position: absolute;
//   top: 50%;
//   -ms-transform: translateY(-50%);
//   transform: translateY(-50%);
}
</style>
